class QuantityInputHandler {
  constructor(selector = '.quantity__input--desktop') {
    this.selector = selector;
    this.init();
    this.observeDOM();
  }

  init() {
    document.querySelectorAll(this.selector).forEach((input) => {
      if (input.dataset.quantityInit) return;
      input.dataset.quantityInit = 'true';
      input.addEventListener('input', (e) => {
        this.handleInput(e.target);
      });
    });
  }

  handleInput(input) {
    const min = parseInt(input.min) || 1;
    const value = parseInt(input.value);
    if (value < min || isNaN(value)) {
      input.value = min;
    }
  }

  observeDOM() {
    const observer = new MutationObserver(() => {
      this.init();
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new QuantityInputHandler();
});

class ResponsiveQuantityInputs {
  constructor({
    containerSelector = '.product-form__quantity',
    desktopSelector = '.quantity__input--desktop',
    mobileSelector = '.quantity__input--mobile',
    breakpoint = '(min-width: 1001px)',
  } = {}) {
    this.containerSelector = containerSelector;
    this.desktopSelector = desktopSelector;
    this.mobileSelector = mobileSelector;
    this.mediaQuery = window.matchMedia(breakpoint);

    this.handleInputs = this.handleInputs.bind(this);

    this.observeDOM();
    this.init();

    this.mediaQuery.addEventListener('change', this.handleInputs);
  }

  handleInputs() {
    document.querySelectorAll(this.containerSelector).forEach((form) => {
      const desktopInput = form.querySelector(this.desktopSelector);
      const mobileInput = form.querySelector(this.mobileSelector);

      if (!desktopInput || !mobileInput) return;

      if (this.mediaQuery.matches) {
        // Desktop
        desktopInput.disabled = false;
        mobileInput.disabled = true;
      } else {
        // Mobile
        desktopInput.disabled = true;
        mobileInput.disabled = false;
      }
    });
  }

  init() {
    this.handleInputs();
  }

  observeDOM() {
    const observer = new MutationObserver(() => {
      this.handleInputs();
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new ResponsiveQuantityInputs();
});
